import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  selected: {},
  isLoaded: false,
  profile: {},
};

const normalizePriceItem = (item) => {
  if (!item || typeof item !== "object") {
    return undefined;
  }

  const resolvedType =
    item.type ??
    item.Type ??
    item.serviceType ??
    item.ServiceType ??
    item.serviceTitle ??
    item.ServiceTitle ??
    item.title ??
    item.Title ??
    "";

  const resolvedAmount =
    item.amount ??
    item.Amount ??
    item.price ??
    item.Price ??
    item.value ??
    item.Value ??
    "";

  const resolvedCurrency =
    item.currency ??
    item.Currency ??
    item.currencyCode ??
    item.CurrencyCode ??
    item.currency ??
    "TRY";

  const resolvedId =
    item.id ??
    item.Id ??
    item.priceId ??
    item.PriceId ??
    item.priceID ??
    item.PriceID ??
    (resolvedType
      ? `${resolvedType}-${resolvedCurrency}-${resolvedAmount}`
      : undefined);

  const resolvedDoctorName =
    item.doctorName ?? item.DoctorName ?? "";
  const resolvedProfessionName =
    item.professionName ??
    item.ProfessionName ??
    item.specialtyCategoryName ??
    item.SpecialtyCategoryName ??
    "";
  const resolvedSpecialtyName =
    item.specialtyName ??
    item.SpecialtyName ??
    item.branchName ??
    item.BranchName ??
    "";

  return {
    ...item,
    id: resolvedId ?? `price-${Date.now()}`,
    type: resolvedType,
    amount: resolvedAmount !== undefined && resolvedAmount !== null ? String(resolvedAmount) : "",
    currency: resolvedCurrency || "",
    doctorName: resolvedDoctorName,
    professionName: resolvedProfessionName,
    specialtyName: resolvedSpecialtyName,
    specialtyCategoryName: resolvedProfessionName,
    branchName: resolvedSpecialtyName,
  };
};

const extractPriceArray = (payload) => {
  if (!payload) return [];

  const candidates = [
    payload,
    payload?.data,
    payload?.Data,
    payload?.result,
    payload?.Result,
    payload?.items,
    payload?.Items,
    payload?.value,
    payload?.Value,
    payload?.data?.data,
    payload?.data?.items,
  ];

  for (const candidate of candidates) {
    if (Array.isArray(candidate)) {
      return candidate
        .map(normalizePriceItem)
        .filter((item) => Boolean(item));
    }
  }

  return [];
};

const extractSinglePriceItem = (payload) => {
  if (!payload) return undefined;

  if (Array.isArray(payload)) {
    return normalizePriceItem(payload[0]);
  }

  const candidates = [
    payload.data,
    payload.Data,
    payload.result,
    payload.Result,
    payload.item,
    payload.Item,
    payload.value,
    payload.Value,
  ];

  for (const candidate of candidates) {
    if (!candidate) continue;
    if (Array.isArray(candidate)) {
      if (candidate.length === 0) continue;
      const normalized = normalizePriceItem(candidate[0]);
      if (normalized) return normalized;
    } else if (typeof candidate === "object") {
      const normalized = normalizePriceItem(candidate);
      if (normalized) return normalized;
    }
  }

  return normalizePriceItem(payload);
};

const priceSlice = createSlice({
  name: "postComment",
  initialState,
  reducers: {
    setPrice: (state, { payload }) => {
      state.list = extractPriceArray(payload);
      state.isLoaded = true;
    },
    setSelectedPrice: (state, { payload }) => {
      state.selected = normalizePriceItem(payload) ?? {};
    },
    updatePriceList: (state, { payload }) => {
      const updatedItem = extractSinglePriceItem(payload);
      if (!updatedItem?.id) return;
      state.list = state.list.map((item) =>
        item.id === updatedItem.id ? { ...item, ...updatedItem } : item
      );
    },
    removePriceToList: (state, { payload }) => {
      state.list = state.list.filter((item) => item.id !== payload);
    },
    clearSelectedPrice: (state) => {
      state.selected = {};
    },
    addPriceToList: (state, { payload }) => {
      const newItem = extractSinglePriceItem(payload);
      if (!newItem) return;
      state.list = [...state.list, newItem];
    },
  },
});

export const {
  setPrice,
  setSelectedPrice,
  updatePriceList,
  removePriceToList,
  clearSelectedPrice,
  addPriceToList,
} = priceSlice.actions;
export default priceSlice.reducer;
